import deepClone from "lodash.clonedeep";
import mixpanel from "mixpanel-browser";
import React, { useContext, useEffect, useState } from "react";
import Rating from "react-rating";
import { toast } from "react-toastify";
import { Activity, currentRequestTimeStamp } from "../../../Constants";
import transport_alt from "../../../Content/images/transporter_logo.png";
import { Urls } from "../../../Urls";
import NewProfileModal from "../../Shared/NewTransporterProfileModal/NewProfileModal";
import Unauthorized from "../../Unauthorized";
import {
  ContextConstants,
  useAppContext,
} from "../../UserContext/TransporterCompareContext";
import Compare from "../CompareNow/CompareNow";
import { ShortlistTransporter, getImageSrc } from "../Utitlity";
import classes from "./Transporterlist.module.css";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

let isMobile = window.innerWidth < 600;

const TransporterRating = ({ overall_rating, number_of_ratings }) => {
  return (
    <span>
      {overall_rating ? (
        <Rating
          initialRating={overall_rating}
          emptySymbol={`fa fa-star-o fa-2x ${classes["customstar1"]}`}
          fullSymbol={`fa fa-star fa-2x ${classes["customstar1"]}`}
          quiet={true}
          readonly={true}
        />
      ) : null}
      {number_of_ratings ? `(${number_of_ratings} Ratings)` : null}
    </span>
  );
};

const TransporterCountList = ({
  transporter_data,
  skipactive,
  total_count,
}) => {
  return (
    <>
      {transporter_data.length > 0 || total_count > 0 ? (
        <div style={{ marginLeft: "2%" }}>
          <div>
            <label>{`Displaying ${(skipactive - 2) * 10 + 11} - ${(skipactive - 2) * 10 + 10 + transporter_data.length
              } of ${total_count} transporters`}</label>
          </div>
        </div>
      ) : null}
    </>
  );
};

const TransporterItem = ({
  imageFallBack,
  transporter,
  index,
  getCompareStatus,
  handleOpenModal,
  toggleShortlist,
}) => {
  if (!isMobile) {
    return (
      <div
        className={`${classes["transporter_item"]}`}
        key={`transporter${index}`}
      >
        <div className="row">
          <div className="col-md-2">
            <div className={`${classes["avatar-circle"]}`}>
              <img
                alt="img"
                style={{ borderRadius: "10px" }}
                src={getImageSrc(transporter.logo)}
                onError={(e) => imageFallBack(e)}
              />
            </div>
          </div>
          <div className={`col-md-5 ${classes["transporter_data"]}`}>
            <div>
              {transporter.transporter_name ? (
                <button
                  className="btn btn-link"
                  onClick={() =>
                    handleOpenModal({
                      id: transporter.transporter_id,
                      name: transporter.transporter_name,
                    })
                  }
                >
                  {transporter.transporter_name}
                </button>
              ) : (
                "-"
              )}
            </div>
            <div style={{ marginLeft: "3%" }}>
              {transporter.overall_rating ? (
                <TransporterRating
                  overall_rating={transporter.overall_rating}
                  number_of_ratings={transporter.number_of_ratings}
                />
              ) : (
                "-"
              )}
              <span>&nbsp;|&nbsp;</span>
            </div>
          </div>
          <div className={`${classes["Transporter_actions"]} col-md-5`}>
            <button
              // data-toggle="tooltip"
              // data-placement="top"
              title="Find your shortlisted transporters in My Account"
              type="button"
              className={
                transporter.is_shortlist
                  ? "btn btn-success btn-sm"
                  : "btn btn-primary btn-sm"
              }
              onClick={() => toggleShortlist(transporter, index)}
            >
              <i className="fas fa-bookmark"></i>{" "}
              {transporter.is_shortlist ? "Shortlisted" : "Shortlist"}
            </button>
            {getCompareStatus(transporter, index)}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="card"
        key={`transporter${index}`}
        style={{
          border: "1px solid lightgrey",
          alignItems: "center",
          padding: "1%",
          margin: "1%",
        }}
      >
        <div className={`${classes["avatar-circle"]}`}>
          <img
            alt="img"
            style={{ borderRadius: "10px" }}
            src={getImageSrc(transporter.logo)}
            onError={(e) => imageFallBack(e)}
          />
        </div>
        <div>
          {transporter.transporter_name ? (
            <button
              className="btn btn-link"
              onClick={() =>
                handleOpenModal({
                  id: transporter.transporter_id,
                  name: transporter.transporter_name,
                })
              }
            >
              {transporter.transporter_name}
            </button>
          ) : (
            "-"
          )}
        </div>
        <div>
          {transporter.overall_rating ? (
            <TransporterRating
              overall_rating={transporter.overall_rating}
              number_of_ratings={transporter.number_of_ratings}
            />
          ) : (
            "-"
          )}
          <span>&nbsp;|&nbsp;</span>
        </div>
        <div style={{ display: "flex" }}>
          <button
            // data-toggle="tooltip"
            // data-placement="top"
            title="Find your shortlisted transporters in My Account"
            type="button"
            className={
              transporter.is_shortlist
                ? "btn btn-success btn-sm"
                : "btn btn-primary btn-sm"
            }
            onClick={() => toggleShortlist(transporter, index)}
          >
            <i className="fas fa-bookmark"></i>{" "}
            {transporter.is_shortlist ? "Shortlisted" : "Shortlist"}
          </button>
          {getCompareStatus(transporter, index)}
        </div>
      </div>
    );
  }
};

const TransporterList = ({
  transporter_data = [],
  getDataOnLoadRequest,
  isAllowed = "no",
  total_count,
  skipactive,
  exhaushted,
  policydata,
}) => {
  const show = false;
  const [canCompare, setcanCompare] = useState("no");

  const { dispatch, currentList = [] } = useAppContext();

  const [transporterModalVisible, setTransporterModalVisible] = useState(false);
  const [activeTransporter, setActiveTransporter] = useState(null);
  const { userDetails } = useContext(UserApiContext);

  const handleOpenModal = (transporter) => {
    setActiveTransporter(transporter);
    setTransporterModalVisible(true);
  };

  const handleCloseModal = () => {
    setTransporterModalVisible(false);
    setActiveTransporter(null);
  };

  useEffect(() => {
    if (policydata) {
      setcanCompare(policydata?.policy?.comparenow?.allowed ?? "no");
    }
  }, [policydata]);

  const AddtoCompare = (transporter) => {
    if (
      currentList.filter(
        (item) => item.transporter_id === transporter.transporter_id
      ).length === 0
    ) {
      Activity([
        {
          screen: "DiscoverNow",
          module: "Compare Transporter",
          user_activity: `${transporter.transporter_name} is added to compare`,
          timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
          , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
        },
      ]);
      mixpanel.track(
        `User has clicked ${transporter.is_shortlist ? "compare" : "removed from compare"
        } button`,
        {
          ApplicationName: `${Urls.mixpanelappname}`,
          ScreenName: "LoRRI-Discovernow",
          ModuleName: "landing_page",
          ActivityLog: "userClickedCompareButton",
          Data: `${transporter.transporter_name} is added to compare`,
          Definition: `User has clicked ${transporter.is_shortlist ? "compare" : "removed from compare"
            } button`,
          ActivityType: "event_view",
          UserName: userDetails?.user_name,
          UserEmail: userDetails?.email,
          CompanyName: userDetails.company_name
            ? userDetails.company_name
            : userDetails.email
              ? userDetails.email.split("@")[1].split(".")[0]
              : ""
        }
      );
      if (currentList.length === 3) {
        alert("You can Compare Only 3 Transporters at a Time");
      } else {
        currentList.push({
          ...deepClone({
            transporter_id: transporter.transporter_id,
            transporter_name: transporter.transporter_name,
          }),
        });
        dispatch({
          type: ContextConstants.addTransportertoList,
          payload: currentList,
        });
      }
    } else {
      Activity([
        {
          screen: "DiscoverNow",
          module: "Compare Transporter",
          user_activity: `${transporter.transporter_name} is removed from compare`,
          timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
          , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
        },
      ]);
      dispatch({
        type: ContextConstants.removeTransporterFromList,
        payload: currentList.filter(
          (item) => item.transporter_id !== transporter.transporter_id
        ),
      });
    }
  };

  const toggleShortlist = (transporter) => {
    ShortlistTransporter(
      transporter.transporter_id,
      transporter.transporter_name,
      transporter.is_shortlist
    )
      .then(() => {
        getDataOnLoadRequest(
          transporter_data.map((item) => {
            if (item.transporter_id === transporter.transporter_id) {
              item.is_shortlist = !item.is_shortlist;
            }
            return item;
          })
        );

        Activity([
          {
            screen: "DiscoverNow",
            module: "Search",
            user_activity: `${transporter.transporter_name} is ${transporter.is_shortlist
              ? "shortlisted"
              : "removed from shortlist"
              }`,
            timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
            , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
          },
        ]);
        mixpanel.track(
          `User has clicked  ${transporter.is_shortlist ? "shortlisted" : "removed from shortlist"
          } button`,
          {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: "LoRRI-Discovernow",
            ModuleName: "landing_page",
            ActivityLog: "userClickedSearchLane",
            Data: `${transporter.transporter_name} is ${transporter.is_shortlist
              ? "shortlisted"
              : "removed from shortlist"
              }`,
            Definition: `User has clicked  ${transporter.is_shortlist
              ? "shortlisted"
              : "removed from shortlist"
              } button`,
            ActivityType: "event_view",
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
              ? userDetails.company_name
              : userDetails.email
                ? userDetails.email.split("@")[1].split(".")[0]
                : ""
          }
        );
        !transporter.is_shortlist
          ? toast.info("Removed from Shortlist")
          : toast.success("Added to Shortlist");
      })
      .catch(() => {
        transporter.is_shortlist
          ? toast.error("Failed to Remove from Shortlist")
          : toast.error("Failed to Shortlist Transporter");
      });
  };

  const getCompareStatus = (transporter) => {
    if (
      currentList.filter(
        (item) => item.transporter_id === transporter.transporter_id
      ).length === 1
    ) {
      return isMobile ? (
        <button
          className={`btn btn-danger btn-sm`}
          style={{ marginLeft: "1%" }}
          title={
            canCompare === "no"
              ? "You do not have permission to compare"
              : "Compare Transporters"
          }
          disabled={canCompare === "no" ? true : false}
          type="button"
          onClick={() => AddtoCompare(transporter)}
        >
          <i className="fas fa-close"></i> Remove From Compare
        </button>
      ) : (
        <button
          style={{ marginLeft: "10%" }}
          title={
            canCompare === "no"
              ? "You do not have permission to compare"
              : "Compare Transporters"
          }
          disabled={canCompare === "no" ? true : false}
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => AddtoCompare(transporter)}
        >
          <i className="fas fa-close"></i> Remove From Compare
        </button>
      );
    } else {
      return isMobile ? (
        <button
          className={`btn btn-primary btn-sm`}
          style={{ marginLeft: "1%" }}
          title={
            canCompare === "no"
              ? "You do not have permission to compare"
              : "Compare Transporters"
          }
          disabled={canCompare === "no" ? true : false}
          type="button"
          onClick={() => AddtoCompare(transporter)}
        >
          <i className="fas fa-plus"></i> Add To Compare
        </button>
      ) : (
        <button
          style={{ marginLeft: "10%" }}
          title={
            canCompare === "no"
              ? "You do not have permission to compare"
              : "Compare Transporters"
          }
          disabled={canCompare === "no" ? true : false}
          type="button"
          className="btn btn-primary btn-sm"
          onClick={() => AddtoCompare(transporter)}
        >
          <i className="fas fa-plus"></i> Add To Compare
        </button>
      );
    }
  };

  const imageFallBack = (e) => {
    e.target.src = transport_alt;
  };


  return !isMobile ? (
    <>
      {isAllowed === "yes" && !exhaushted ? (
        <>
          <TransporterCountList
            transporter_data={transporter_data}
            skipactive={skipactive}
            total_count={total_count}
          />
          <div
            id="transporter_container_list"
            className={`${classes["transporter_container"]} col-12`}
          >
            {total_count === 0 ? (
              <div className={`${classes["s-noresult"]}`}>
                <h3>No results found</h3>
              </div>
            ) : (
              transporter_data?.map((item, index) => (
                <TransporterItem
                  imageFallBack={imageFallBack}
                  transporter={item}
                  index={index}
                  key={`transporter${index}`}
                  getCompareStatus={getCompareStatus}
                  handleOpenModal={handleOpenModal}
                  toggleShortlist={toggleShortlist}

                />
              ))
            )}
            <div
              className={`justify-content-center ${classes["spinner_container"]}`}
            >
              {show ? (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ textAlign: "center" }}
                />
              ) : null}
            </div>
            <Compare />
          </div>

          {transporterModalVisible && activeTransporter && (
            <NewProfileModal
              isOpen={transporterModalVisible}
              onClose={handleCloseModal}
              transporter_id={activeTransporter.id}
              transporter_name={activeTransporter.name}
              screenName="Discover Now"
              moduleName="Discover Now"
              transporter_list={transporter_data}
            />
          )}
        </>
      ) : (
        <Unauthorized message="You have Exhausted your credits" />
      )}
    </>
  ) : isAllowed === "yes" ? (
    <>
      <div>
        <TransporterCountList
          transporter_data={transporter_data}
          skipactive={skipactive}
          total_count={total_count}
        />
      </div>
      <div
        id="transporter_container_list"
        className={`${classes["transporter_container"]} col-12`}
      >
        {total_count === 0 ? (
          <div className={`${classes["s-noresult"]}`}>
            <h3>No results found</h3>
          </div>
        ) : (
          transporter_data.map((item, index) => (
            <TransporterItem
              imageFallBack={imageFallBack}
              transporter={item}
              index={index}
              key={`transporter_${index}`}
              getCompareStatus={getCompareStatus}
              handleOpenModal={handleOpenModal}
              toggleShortlist={toggleShortlist}
            />
          ))
        )}
      </div>
      <Compare />
    </>
  ) : (
    <Unauthorized message="You have Exhausted your credits" />
  );
};

export default TransporterList;
